import { Bitmap, Container, dispatcher, IEvent, ingenuity, ITween, Linear } from "@quest/base-core";
import { BlurBackgroundController } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { IEvent as inEvent } from "@quest/adapter-interface";
export class BlurBackgroundControllerGame extends BlurBackgroundController {
  private blurBgFadeInDuration: number = 500;
  private blurBgFadeOutDuration: number = 300;
  private bonusGameBGContainer: Container;
  private bonusGameBlurBg: Bitmap;
  private bonusGameOutroBlurBg: Bitmap;
  private bonusGameJackpotBlurBg: Bitmap;
  protected initializeElements(): void {
    super.initializeElements();
    this.bonusGameBGContainer = this.view.getContainerByID("bonusGameBlurContainer");
    this.bonusGameOutroBlurBg = this.view.getImageById("bonusGameOutroBlurBg");
    this.bonusGameJackpotBlurBg = this.view.getImageById("bonusGameJackpotBlurBg");
  }

  // Overrided to subscribe game end event
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_POP_UP_BLUR_BG, this.showPopUpBlurBg, this);
    dispatcher.on(eventDispatchers.SHOW_BONUS_OUTRO, this.showBonusOutro, this);

    dispatcher.on(eventDispatchers.HIDE_POP_UP_BLUR_BG, this.hideBlurBgWithFadeOutEffect, this);
  }

  // Overrided to unsubscribe game end event
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_POP_UP_BLUR_BG, this.showPopUpBlurBg, this);
    dispatcher.off(eventDispatchers.SHOW_BONUS_OUTRO, this.showBonusOutro, this);
    dispatcher.off(eventDispatchers.HIDE_POP_UP_BLUR_BG, this.hideBlurBgWithFadeOutEffect, this);
  }

  /**
   * overide to change background for 'hold n respin'
   * @param evt 
   */
  protected changeBackground(evt: inEvent): void {
    if (evt.data === gameConstants.HOLD_RESPIN_BG_SHOW) {
      this.hideAllBg();
      this.showBonusGameBg();
    } else {
      super.changeBackground(evt);
    }
  }
  /**
   * overrided to hide bonus bg container
   */
  protected hideAllBg(): void {
    super.hideAllBg();
    this.bonusGameBGContainer.visible = false;
    this.bonusGameOutroBlurBg.visible = false;
    this.bonusGameJackpotBlurBg.visible = false;
  }
  /**
   * function to show bonus bg
   */
  private showBonusGameBg(): void {
    this.bonusGameBlurBg = this.view.getImageById("bonusGameBlurBg");
    this.bonusGameBGContainer.visible = true;
    this.bonusGameBGContainer.alpha = 0;
    if (ingenuity.deviceEnv.isDesktop) {
      this.bonusGameBlurBg.visible = true;
      this.bonusGameBlurBg.alpha = 1;
    }
    const apperBonusBG = ingenuity.currentGame.add.tween(this.bonusGameBGContainer);
    apperBonusBG.to({ alpha: 1 }, 1000, Linear.None, true);
    apperBonusBG.onComplete.add(() => {
      ingenuity.currentGame.tweens.remove(apperBonusBG);
    }, this);
  }

  private showBonusOutro(evt: IEvent): void {
    switch (evt.data) {
      case "BONUS_OUTRO":
        this.bonusGameBGContainer.visible = true;
        this.hideBgCallBack([this.bonusGameJackpotBlurBg]);
        this.showWithFadeIn(this.bonusGameOutroBlurBg);
        break;
      case "JACKPOT_OUTRO":
        this.bonusGameBGContainer.visible = true;
        this.hideBgCallBack([]);
        this.showWithFadeIn(this.bonusGameJackpotBlurBg);
        break;
    }
  }

  private showWithFadeIn(image: Bitmap): void {
    image.alpha = 0;
    const apperBonusBG = ingenuity.currentGame.add.tween(image);
    apperBonusBG.to({ alpha: 1 }, 1000, Linear.None, true);
    apperBonusBG.onComplete.add(() => {
      ingenuity.currentGame.tweens.remove(apperBonusBG);
    }, this);
  }

  // Add to show Big win, Fg Intro & Outro blur background
  private showPopUpBlurBg(evt: IEvent): void {
    const superWinBlurBg: Bitmap = this.view.getImageById("superWinBlurBg");
    const bigwinBlurImage: Bitmap = this.view.getImageById("bigwinBlurImage");
    const epicWinBlurBg: Bitmap = this.view.getImageById("epicWinBlurBg");
    const crazyWinBlurBg: Bitmap = this.view.getImageById("crazyWinBlurBg");
    switch (evt.data) {
      case gameConstants.SHOW_BIG_WIN_BLUR_BG:
        if (!bigwinBlurImage.visible) this.showBlurBgWithFadeInEffect(bigwinBlurImage, this.hideBgCallBack, []);
        break;
      case gameConstants.SHOW_SUPER_WIN_BLUR_BG:
        if (!superWinBlurBg.visible) this.showBlurBgWithFadeInEffect(superWinBlurBg, this.hideBgCallBack, [bigwinBlurImage]);
        break;
      case gameConstants.SHOW_EPIC_WIN_BLUR_BG:
        if (!epicWinBlurBg.visible) this.showBlurBgWithFadeInEffect(epicWinBlurBg, this.hideBgCallBack, [bigwinBlurImage, superWinBlurBg]);
        break;
      case gameConstants.SHOW_CRAZY_WIN_BLUR_BG:
        if (!crazyWinBlurBg.visible)
          this.showBlurBgWithFadeInEffect(crazyWinBlurBg, this.hideBgCallBack, [bigwinBlurImage, superWinBlurBg, epicWinBlurBg]);
        break;
      case gameConstants.SHOW_FG_INTRO_BLUR_BG:
        const introBlurBg: Bitmap = this.view.getImageById(
          "Pick_Screen_BG_" + (ingenuity.parserModel as GameParserModel).getFreeSpinNum() + "_freeSpins"
        );
        this.showBlurBgWithFadeInEffect(introBlurBg, this.hideBgCallBack, []);
        break;
      case gameConstants.SHOW_FG_OUTRO_BLUR_BG:
        const outroBlurBg: Bitmap = this.view.getImageById(
          "outroBlurBg_" + (ingenuity.parserModel as GameParserModel).getFreeSpinNum() + "_freeSpins"
        );
        this.showBlurBgWithFadeInEffect(outroBlurBg, this.hideBgCallBack, []);
        break;
    }
  }

  /**
   * TO hide background on callbackground showBlurBgWithFadeInEffect method.
   * @param backgrounds
   * @returns
   */
  private hideBgCallBack(backgrounds: Bitmap[]): void {
    if (!backgrounds.length) return;
    backgrounds.forEach((background: Bitmap) => {
      background.visible = false;
    }, this);
  }

  // Show Blur Background with fade in effect
  private showBlurBgWithFadeInEffect(background: Bitmap, hideBgCallBack: Function, hideBGArray: Bitmap[]): void {
    const popUpBlurBgContainer: Container = this.view.getContainerByID("bigwinBlurContainer");
    popUpBlurBgContainer.alpha = 1;
    background.alpha = 0;
    background.visible = true;
    const BlurBgFadeInTween: ITween = ingenuity.currentGame.add
      .tween(background)
      .to({ alpha: 1 }, this.blurBgFadeInDuration, Linear.None, true, 0, 0, false);
    BlurBgFadeInTween.onComplete.addOnce(() => {
      BlurBgFadeInTween.stop();
      ingenuity.currentGame.tweens.remove(BlurBgFadeInTween);
      hideBgCallBack(hideBGArray);
    }, this);
  }

  // Hide Blur Background with fade out effect
  private hideBlurBgWithFadeOutEffect(): void {
    const popUpBlurBgContainer: Container = this.view.getContainerByID("bigwinBlurContainer");
    const BlurBgFadeOutTween: ITween = ingenuity.currentGame.add
      .tween(popUpBlurBgContainer)
      .to({ alpha: 0 }, this.blurBgFadeOutDuration, Linear.None, true, 0, 0, false);
    BlurBgFadeOutTween.onComplete.addOnce(() => {
      BlurBgFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(BlurBgFadeOutTween);
      this.view.getImageById("bigwinBlurImage").visible = false;
      this.view.getImageById("superWinBlurBg").visible = false;
      this.view.getImageById("epicWinBlurBg").visible = false;
      this.view.getImageById("crazyWinBlurBg").visible = false;
    }, this);
  }
}
